import AssessmentServiceApi from "../../services/assessment-api";
import {
  getPortalCD,
  readCookie,
  getFallbackIPAddress,
} from "../../utils/helpers";
import { EMPTY_GUID } from "../../utils/constants";
import { toast } from "react-toastify";
import { getI18n } from "react-i18next";

const forgotPassword = (params) => {
  return function () {
    return AssessmentServiceApi.forgotPassword(params)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
};

const saveLoginAttemptAndForgotPassword = (data) => {
  return async function () {
    let ipAddress = data?.ipAddress;

    if (!ipAddress) {
      ipAddress = await getFallbackIPAddress();
    }

    const loginAttemptReq = {
      emailAddress: data.email.trim(),
      ipAddress: ipAddress,
      attemptType: data.attemptType || "ForgotPassword",
      visitorId: readCookie("visitorGuid"),
      visitId: readCookie("visitGuid"),
      createdBy: readCookie("visitorGuid"),
      portalCD: getPortalCD(data.locale),
      greCaptchaToken: "",
      isCaptchaRequired: false,
    };

    return AssessmentServiceApi.loginAttempt(loginAttemptReq)
      .then((loginResponse) => {
        if (
          loginResponse?.statusCode === 426 &&
          loginResponse?.error === "maximum_login_attempt"
        ) {
          throw new Error(getI18n().t("login.maximum_login_attempt"));
        } else if (loginResponse?.error && loginResponse.error !== "") {
          throw new Error(loginResponse.error);
        }
        const params = {
          serviceCode: "",
          email: data.email,
          locale: data.locale,
        };
        return AssessmentServiceApi.forgotPassword(params).then(
          (forgotPasswordResponse) => {
            if (forgotPasswordResponse) {
              toast.success(getI18n().t("account.forgot_password_tostmsg"));
            }
            return forgotPasswordResponse;
          },
        );
      })
      .catch((error) => {
        console.error("[LoginAttempt] Error:", error);
        throw error;
      });
  };
};

export { forgotPassword, saveLoginAttemptAndForgotPassword };
